"use strict";
exports.__esModule = true;
exports.OrganisationDocument = void 0;
var persona_1 = require("./persona");
var status_1 = require("./status");
var OrganisationDocument = /** @class */ (function () {
    function OrganisationDocument(id, name, domain, owner, trial, status, suspended_reason, is_eu, is_verified, //Is one of our guys verified it
    license_end_on, //Any type of subscription pro, paid
    app_domain, address, country, currency, currency_format, persona, created_at, updated_at, created_by, updated_by) {
        this.id = id;
        this.name = name;
        this.domain = domain;
        this.owner = owner;
        this.trial = trial;
        this.status = status;
        this.suspended_reason = suspended_reason;
        this.is_eu = is_eu;
        this.is_verified = is_verified;
        this.license_end_on = license_end_on;
        this.app_domain = app_domain;
        this.address = address;
        this.country = country;
        this.currency = currency;
        this.currency_format = currency_format;
        this.persona = persona;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.created_by = created_by;
        this.updated_by = updated_by;
    }
    // ₹
    OrganisationDocument.fromJSON = function (json) {
        var organisation = new OrganisationDocument('', '', '', '', false, status_1.OrgStatus.FREE, '', false, false, 0, '', '', '', '', '', [], 0, 0, '', '');
        if (json) {
            organisation.id = json.id ? json.id : '';
            organisation.name = json.name ? json.name : '';
            organisation.domain = json.domain ? json.domain : '';
            organisation.owner = json.owner ? json.owner : '';
            organisation.trial = json.trial !== undefined ? json.trial : false;
            organisation.status = json.status ? json.status : status_1.OrgStatus.FREE;
            organisation.suspended_reason = json.suspended_reason ? json.suspended_reason : '';
            organisation.is_eu = json.is_eu !== undefined ? json.is_eu : false;
            organisation.is_verified = json.is_verified !== undefined ? json.is_verified : false;
            organisation.license_end_on = json.license_end_on ? json.license_end_on : 0;
            organisation.app_domain = json.app_domain ? json.app_domain : '';
            organisation.address = json.address ? json.address : '';
            organisation.country = json.country ? json.country : '';
            organisation.currency = json.currency ? json.currency : '';
            organisation.currency_format = json.currency_format ? json.currency_format : '';
            organisation.persona = json.persona ? json.persona : '';
            organisation.persona = json.persona.length ? json.persona.map(function (persona) { return persona_1.Persona.fromJSON(persona); }) : [];
            organisation.created_at = json.created_at ? json.created_at : 0;
            organisation.updated_at = json.updated_at ? json.updated_at : 0;
            organisation.created_by = json.created_by ? json.created_by : '';
            organisation.updated_by = json.updated_by ? json.updated_by : '';
        }
        return organisation;
    };
    return OrganisationDocument;
}());
exports.OrganisationDocument = OrganisationDocument;
